import codepen from "../assets/codepen.jpg";
import iNotebook from "../assets/iNotebook.jpg";
import ecommerceWebsite from "../assets/ecommerceWebsite.jpg";
import news_app from "../assets/news_app.jpg";
import textAnalyzer from "../assets/textAnalyzer.jpg";
import stickyNotes from "../assets/stickyNotes.jpg";
import todoList from "../assets/todoList.jpg";
import weather from "../assets/weather.jpg";
import SchoolLogo from "../assets/SchoolLogo.png";
import EducationDoc from "../assets/EducationDoc.png";
import SerenityBDD from "../assets/Serenity-BDD.png"
export const Bio = {
    name: "Bobby Tripathi",
    roles: [
        "Full Stack Developer",
        "Frontend Developer",
        "Software Developer",
        "Programmer",
    ],
    description:
        "Aspiring candidate with a solid foundation in software development, showcasing proficiency in key programming languages and frameworks.Eager to contribute to innovative projects and collaborate effectively within team environments.Committed to continuous growth and adapting to evolving technologies for impactful contributions in dynamic work settings.",
    github: "https://github.com/Bobby278tr",
    resume:
        "https://drive.google.com/file/d/14iBZzpmM_d85rvEBp6B4V7opWglsCgBu/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/bobby-tripathi-b178361b5/"
};

export const skills = [
    {
        title: "Frontend",
        skills: [
            {
                name: "React Js",
                image:
                    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
            },
            {
                name: "Redux",
                image:
                    "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
            },
            {
                name: "HTML",
                image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
            },
            {
                name: "CSS",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
            },
            {
                name: "JavaScript",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
            },
            {
                name: "Bootstrap",
                image:
                    "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
            },
            {
                name: "NPM",
                image:"https://upload.wikimedia.org/wikipedia/commons/d/db/Npm-logo.svg"
            }
        ],
    },
    {
        title: "Backend",
        skills: [
            {
                name: "Node Js",
                image: "https://nodejs.org/static/images/logo.svg",
            },
            {
                name: "Express Js",
                image:
                    "data:image/png;base64,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",
            },
            {
                name: "Python",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
            },
            {
                name: "MySQL",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
            },
            {
                name: "MongoDB",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
            },
            {
                name: "Firebase",
                image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
            },
        ],
    },
    {
        title: "Language and Framework",
        skills: [
            {
                name: "Java",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
            },
            {
                name: "Cypress",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/8/8f/Cypress-logo.webp",
            },
            {
                name: "Serenity(BDD)",
                image: SerenityBDD
            },
        ],
    },
    {
        title: "Others",
        skills: [
            {
                name: "Git",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/e/e0/Git-logo.svg",
            },
            {
                name: "GitHub",
                image:
                    "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
            },
            {
                name: "Docker",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
            },
            {
                name: "Kuberntes",
                image: "https://upload.wikimedia.org/wikipedia/commons/6/67/Kubernetes_logo.svg"
            },
            {
                name: "Linux",
                imgae: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Tux.svg/800px-Tux.svg.png"
            },
            {
                name: "VS Code",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
            },
            {
                name: "Postman",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/c/c2/Postman_%28software%29.png",
            },
        ],
    },
];

export const experiences = [
    {
        id: 0,
        img: "https://upload.wikimedia.org/wikipedia/commons/archive/c/ca/20230305131810%21Nokia_2023.svg",
        role: "Student Intern",
        company: "Nokia Solutions and Network",
        date: "July 2022 - June 2023",
        desc: "Innovated UI elements with React and JavaScript, implemented Behavior-Driven Development and Cypress for rigorous testing, and actively engaged in code reviews, debugging, and quality assurance for successful product launches.",
        skills: [
            "ReactJs",
            "JavaScript",
            "Java",
            "Cypress",
            "Behavior-Driven Development",
            "Git",
            "Linux",
            "Docker",
            "Kubernetes"
        ],
        doc: "https://drive.google.com/file/d/1NAHPq6-4UA9YoJqbDEXXJ8nyMqZ3X8aQ/view?usp=sharing",
        logo: EducationDoc
    },
];

export const educations = [
    {
        id: 0,
        img: "https://upload.wikimedia.org/wikipedia/commons/a/af/GU_l.jpg",
        school: "Galgotias University, Greater Noida",
        date: "Sep 2019 - June 2023",
        grade: "9.12 CGPA",
        desc: 'I graduated with a Bachelor of Technology in Computer Science and Engineering from Galgotias University, Greater Noida, India, with a GPA of 9.1 (2019-2023). During my academic journey, I published a research paper titled "Adaptive Website with Ranked Pages Using Firefly Optimization" at the International Conference on Information Systems and Computer Networks, showcasing my interest and expertise in innovative web technologies and optimization algorithms.',
        degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
        id: 1,
        img: SchoolLogo,
        school: "St. Giri Public School, New Delhi",
        date: "Apr 2018 - Apr 2019",
        grade: "85%",
        desc: "I completed my class 12 high school education at St. Giri Public School, New Delhi, where I studied Science.",
        degree: "CBSE(XII), Science PCM",
      },
      {
        id: 2,
        img: SchoolLogo,
        school: "St. Giri Public School, New Delhi",
        date: "Apr 2016 - Apr 2017",
        grade: "92.3%",
        desc: "I completed my class 10 education at St. Giri Public School, New Delhi.",
        degree: "CBSE(X)",
      },
];

export const projects = [
    {
        id: 9,
        title: "CODEPEN CLONE",
        date: "May 2024 - June 2024",
        description:
            "Built a CodePen-like app that enables users to create, save, and view HTML, CSS, and JavaScript projects with real-time saving and retrieval for a seamless and interactive experience. user can login or singup through three different methods that are : Username Password, Google Authentication, and Github Authentication ",
        image:
            codepen,
        tags: [
            "Redux",
            "React",
            "JavaScript",
            "HTML/CSS",
            "Firebase",
            "Tailwind",
            "Axios"
        ],
        category: "web app",
        github: "https://github.com/Bobby278tr/CodePen-Clone.git",
        webapp: "https://codepen-clone-64b8d.web.app/home/auth",
    },
    {
        id: 0,
        title: "iNotebook",
        date: "Feb 2024 - March 2024",
        description:
            "Created a secure note-taking app with user authentication and authorization, allowing users to create unique, password-protected IDs to keep their notes private.",
        image:
            iNotebook,
        tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux", "Bootstrap", "ThunderClient"],
        category: "web app",
        github: "https://github.com/Bobby278tr/iNotebook.git",
        webapp: "https://drive.google.com/file/d/1PnWBAL2yGmUciW1W0hYB1K2WZelAqXzE/view",
    },
    {
        id: 1,
        title: "RESPONSIVE E-COMMERCE WEBSITE",
        date: "Desc 2023 - Jan 2024",
        description:
            'Developed an e-commerce website with responsive design and intuitive user interfaces for seamless adaptability and optimal user experience across devices and platforms.',
        image:
            ecommerceWebsite,
        tags: [
            "HTML",
            "CSS",
            "JavsScript"
        ],
        category: "web app",
        github: "https://github.com/Bobby278tr/Responsive_E-commerce_Website.git",
        webapp: "https://bobby278tr.github.io/Responsive_E-commerce_Website/",
    },
    {
        id: 2,
        title: "DAILY DOSE - NEWS APP",
        date: "Jan 2024 - Feb 2024",
        description:
            'Built "Daily Dose," a news app offering content across various categories with a responsive design and smooth navigation for an intuitive and accessible user experience.',
        image:
            news_app,
        tags: ["React", "JavaScript", "New Api", "React-Router-Dom", "Bootstrap"],
        category: "api app",
        github: "https://github.com/Bobby278tr/React_DailyDose.git",
        webapp: "https://github.com/Bobby278tr/React_DailyDose.git",
    },
    {
        id: 3,
        title: "Text Analyzer",
        date: "Jan 2024 - Feb 2024",
        description:
            "Created a Text-Analyzer app that offers various text analysis functionalities, such as case conversion and space removal, with a user-friendly design featuring customizable color palettes for an enhanced experience.",
        image:
            textAnalyzer,
        tags: ["React", "JavaScript", "HTML/CSS", "Bootstrap"],
        category: "web app",
        github: "https://github.com/Bobby278tr/Text-Analyzer.git",
        webapp: "https://bobby278tr.github.io/Text-Analyzer/",
    },
    {
        id: 10,
        title: "Sticky Notes",
        date: "July 2024 - July 2024",
        description:
            "Developed a Sticky Notes app that allows users to create, edit, and organize notes with an intuitive interface for quick and efficient note-taking.",
        image:
            stickyNotes,
        tags: ["React", "JavaScript", "tailwind", "HTML/CSS", "Local Storage"],
        category: "web app",
        github: "https://github.com/Bobby278tr/Sticky_Notes.git",
        webapp: "https://bobby278tr.github.io/Sticky_Notes/",
    },
    {
        id: 4,
        title: "Weather App",
        date: "Jan 2024",
        description:
            "Developed a weather app that provides real-time weather updates, forecasts, and detailed conditions for any location.",
        image:
            weather,
        tags: ["JavaScript", "Weather API", "HTML/CSS", "Local Storage"],
        category: "api app",
        github: "https://github.com/Bobby278tr/Weather-App-.git",
        webapp: "https://bobby278tr.github.io/Weather-App-/",
    },
    {
        id: 5,
        title: "Todo Web App",
        date: "Jan 2024",
        description:
            "Developed a to-do app that allows users to add, edit, delete, and mark tasks as complete, providing an intuitive and organized task management experience.",
        image:
            todoList,
        tags: ["Local Storage", "JavaScript", "HTML/CSS"],
        category: "web app",
        github: "https://github.com/Bobby278tr/To-Do_List.git",
        webapp: "https://bobby278tr.github.io/To-Do_List/",
    }
];
